import createReducer from '@/lib/redux_updeep';
const initialState = {};

export default createReducer('CUSTOMERS', initialState, {});
